import React, { useState, useEffect } from 'react'
import ImageWithBasePath from '../../core/img/imagewithbasebath'
import { Link, useNavigate } from 'react-router-dom'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { setToogleHeader } from '../../core/redux/action';
import { useDispatch, useSelector } from 'react-redux';
import { ChevronUp, RotateCcw, PlusCircle } from 'feather-icons-react/build/IconComponents';
import { Filter } from 'react-feather';
import Select from 'react-select';
// import { DatePicker } from 'antd';
// import AddPurchaseReturn from '../../core/modals/purchases/addpurchasereturn';
import EditPurchaseRequest from '../../core/modals/purchases/editpurchaserequest';
// import Swal from 'sweetalert2';
// import withReactContent from 'sweetalert2-react-content';
import AddPurchaseRequest from '../../core/modals/purchases/addpurchaserequest';
import Axios from "axios";
import { API_BASE_URL, GET_PURCHASE_REQ } from '../../Config';
import ViewApprovedIndents from '../../core/modals/purchases/viewapprovedindents';
import Table from '../../core/pagination/datatable';
import SubmittedToPO from '../../core/modals/purchases/submittedtopo';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ViewConsolidatedIndents from '../../core/modals/purchases/viewconsolidatedindents';
import { getUserPermissions } from "../../UserPermissions";
import ViewPurchaseRequest from '../../core/modals/purchases/viewpurchaserequest';
import SpinLoader from '../loader/SpinLoader';


const PurchaseRequests = () => {

    const [userDataSession, setUserDataSession] = useState([]);
    const [pRData, setPRData] = useState([]);
    const [viewTranData, setViewTranData] = useState('');
    const [editTranData, setEditTranData] = useState('');
    const [submittedToPO, setSubmittedToPO] = useState('');
    const [loading, setLoading] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
        } else {
            console.log("User data not found in sessionStorage");
            navigate('/');
        }
    }, []);

    useEffect(() => {
        if (userDataSession && userDataSession.OrgId) {
            setLoading(true);
            Axios.get(`${API_BASE_URL}${GET_PURCHASE_REQ}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}&RequestDate=NULL&PRStatus=0`)
            .then((response) => {
                setPRData(response.data.ResultData);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.error("Error fetching requests:", error);
            });
        }
    }, [userDataSession]);

    const handleSearchClick = () => {
        if (userDataSession && userDataSession.OrgId && (selectedDate || selectedStatus)) {
            setLoading(true);

            const url =`${API_BASE_URL}${GET_PURCHASE_REQ}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}&RequestDate=${selectedDate && selectedDate ? selectedDate : 'NULL'}&PRStatus=${selectedStatus.value}`;

            Axios.get(url)
            .then((response) => {
                setPRData(response.data.ResultData);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.error("Error fetching stores:", error);
            });
        }
    };

    const statusFilter = [
        { value: '0', label: 'ALL' },
        { value: 'DRAFT', label: 'DRAFT' },
        { value: 'SUBMITTED', label: 'SUBMITTED' },
        { value: 'COMPLETED', label: 'COMPLETED' }
    ];

    const handleDateChange = (event) => {
        const date = event.target.value;
        setSelectedDate(date);
    };

    const handleStatsuChange = (status) => {
        setSelectedStatus(status);
    };

    const dispatch = useDispatch();
    const data = useSelector((state) => state.toggle_header);

    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const toggleFilterVisibility = () => {
        setIsFilterVisible((prevVisibility) => !prevVisibility);
    };

    const renderTooltip = (props) => (
        <Tooltip id="pdf-tooltip" {...props}>
            Pdf
        </Tooltip>
    );
    const renderExcelTooltip = (props) => (
        <Tooltip id="excel-tooltip" {...props}>
            Excel
        </Tooltip>
    );
    // const renderPrinterTooltip = (props) => (
    //     <Tooltip id="printer-tooltip" {...props}>
    //         Printer
    //     </Tooltip>
    // );
    const renderRefreshTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Refresh
        </Tooltip>
    );
    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Collapse
        </Tooltip>
    );
   
    const handleViewClick = (item) => {
        setViewTranData(item);
    };

    const handleEditClick = (item) => {
        setEditTranData(item);
    };

    const handleSubToPOClick = (item) => {
        setSubmittedToPO(item);
    }; 

    const [permissions, setPermissions] = useState({
        isRead: 'd-none',
        isWrite: 'd-none',
        isDelete: 'd-none',
        isExport: 'd-none'
    });
    
    useEffect(() => {
        const perms = getUserPermissions("Purchase Request");
        setPermissions(perms);
    }, []);

    const formatDate = (isoDateString) => {
        const date = new Date(isoDateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
    
        return `${day}-${month}-${year}`;
    };    

    const columns = [
        { title: 'PR-Number', dataIndex: 'AutoGenTransactionNo', key: 'AutoGenTransactionNo',  render: (text) => `PR-${text}`, },
        {
            title: 'Date',
            dataIndex: 'RequestDate',
            key: 'RequestDate',
            render: (text) => formatDate(text),
        },
        { title: 'Store', dataIndex: 'StoreName', key: 'StoreName' },
        { title: 'Supplier', dataIndex: 'SupplierName', key: 'SupplierName' },
        {
            title: 'Status',
            dataIndex: 'PRStatus',
            key: 'PRStatus',
            render: (status) => {
                let badgeClass = '';
                let badgeLabel = '';
        
                switch (status) {
                    case 'DRAFT':
                        badgeClass = 'badge badge-warning';
                        badgeLabel = 'DRAFT';
                        break;
                    case 'SUBMITTED':
                        badgeClass = 'badge badge-info';
                        badgeLabel = 'SUBMITTED';
                        break;
                    case 'COMPLETED':
                        badgeClass = 'badge badge-success';
                        badgeLabel = 'COMPLETED';
                        break;
                    default:
                        badgeClass = 'badge badge-secondary';
                        badgeLabel = status;
                        break;
                }
        
                return <span className={badgeClass}>{badgeLabel}</span>;
            },
        },
        { title: 'Action', key: 'action', 
        
            render: (text, record) => (
                <div>
                    <Link
                            to="#"
                            className="dropdown-toggl"
                            data-bs-toggle="dropdown"
                        >
                            <i className="fa-solid fa-ellipsis-vertical btn border"></i>
                    </Link>
                    <div className="dropdown-menu dropdown-menu-right">
                        <Link 
                            to="#" 
                            className={`dropdown-item`} 
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightPRView"
                            aria-controls="offcanvasRightPRView"
                            onClick={() => handleViewClick(record)}
                        >
                            <i className="fa-regular fa-eye me-2"></i>
                            View
                        </Link>
                        <Link 
                            to="#" 
                            className={`dropdown-item ${record.PRStatus == 'DRAFT' ? '' : 'disabled'} ${permissions.isWrite}`} 
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightPREdit"
                            aria-controls="offcanvasRightPREdit"
                            onClick={() => handleEditClick(record)}
                        >
                            <i className="fa-regular fa-pen-to-square me-2"></i>
                            Edit
                        </Link>
                        <Link 
                            to="#" 
                            className={`dropdown-item ${record.PRStatus == 'SUBMITTED' ? 'disabled' : ''} ${(userDataSession.RoleId === 1 || userDataSession.RoleId === 2 || userDataSession.RoleId === 4) ? '' : 'd-none'}`}
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightSubmitToPO"
                            aria-controls="offcanvasRightSubmitToPO"
                            onClick={() => handleSubToPOClick(record)}
                        >
                            <i className="fa-regular fa-file-lines me-2"></i>
                            Submit to PO
                        </Link>
                    </div>
                </div>
            ),
        },
    ];

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
    };

    const filteredData = pRData && pRData.filter(item => 
        item.AutoGenTransactionNo?.toString().toLowerCase().includes(searchValue.toLowerCase()) ||
        item.StoreName?.toLowerCase().includes(searchValue.toLowerCase()) ||
        item.SupplierName?.toLowerCase().includes(searchValue.toLowerCase())
    );

    const handleDownloadExcel = () => {
        if (filteredData.length === 0) {
          return; // Don't download if there is no data
        }
    
        // Create a new workbook
        const wb = XLSX.utils.book_new();
    
        // Convert your data to worksheet format
        const wsData = filteredData?.map((item) => ({
          PONumber: item.AutoGenTransactionNo,
          Date: formatDate(item.RequestDate),
          Store: item.StoreName,
          Supplier: item.SupplierName,
          Status: item.PRStatus, // Use the status directly
        }));
    
        const ws = XLSX.utils.json_to_sheet(wsData);
    
        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, "PurchaseRequest");
    
        // Save the workbook to a file
        XLSX.writeFile(wb, "PurchaseRequest.xlsx");
      };
    
      const generatePDF = () => {
        const doc = new jsPDF();
    
        // Set properties for PDF
        doc.setProperties({
          title: "Attendance Report",
          author: "Your Name",
          creator: "Your Application",
        });
    
        // Add data to PDF
        const tableData = []; // Your data array here
    
        // Add a header row
        const headers = ["PONumber", "Date", "Store", "Supplier", "Status"];
        tableData.push(headers);
    
        // Add rows
        filteredData.forEach((item) => {
          const row = [];
          row.push(
            item.AutoGenTransactionNo,
            formatDate(item.RequestDate),
            item.StoreName,
            item.SupplierName,
            item.PRStatus // Apply the status mapping
          );
          tableData.push(row);
        });
    
        // Generate table
        doc.autoTable({
          head: [headers],
          body: tableData.slice(1),
        });
    
        // Save the PDF
        doc.save("PurchaseRequest.pdf");
      };
    
    const customStyles = {
        control: (provided) => ({
          ...provided,
          minHeight: "2rem",
          height: "2.4rem",
        }),
    };

    const handleReload = () => {
        window.location.reload();
    }
   

    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Purchase Request List</h4>
                                <h6>Manage your Requests</h6>
                            </div>
                        </div>
                        <ul className="table-top-head">
                            <li onClick={generatePDF} className={`${permissions.isExport}`}>
                                <OverlayTrigger placement="top" overlay={renderTooltip}>
                                    <Link>
                                        <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li onClick={handleDownloadExcel} className={`${permissions.isExport}`}>
                                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            {/* <li>
                                <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <i data-feather="printer" className="feather-printer" />
                                    </Link>
                                </OverlayTrigger>
                            </li> */}
                            <li onClick={handleReload}>
                                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <RotateCcw />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>

                                    <Link
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id="collapse-header"
                                        className={data ? "active" : ""}
                                        onClick={() => { dispatch(setToogleHeader(!data)) }}
                                    >
                                        <ChevronUp />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul>
                        <div className="page-btn">
                            <Link
                                to="#"
                                className={`btn btn-added ${permissions.isRead}`}
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasRightApprInds"
                                aria-controls="offcanvasRightApprInds"
                                // onClick={handleViewApprovedClick}
                            >
                                {/* <PlusCircle className="me-2" /> */}
                                <i className="fa-regular fa-eye me-2"></i>
                                Approved Indents
                            </Link>
                        </div>
                        <div className="page-btn">
                            <Link
                                to="#"
                                className='btn btn-added'
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasRight"
                                aria-controls="offcanvasRight"
                            >
                                <i className="fa-regular fa-eye me-2"></i>
                                Consolidated Indents
                            </Link>
                        </div>
                        <div className="page-btn">
                            <Link
                                to="#"
                                className="btn btn-added"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasRightPRAdd"
                                aria-controls="offcanvasRightPRAdd"
                            >
                                <PlusCircle />
                                {/* Add Request */}
                            </Link>
                        </div>
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-top">
                                <div className="search-set">
                                    <div className="search-input">
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="form-control form-control-sm formsearch"
                                        value={searchValue}
                                        onChange={handleSearchChange}
                                    />
                                        <Link to className="btn btn-searchset">
                                            <i data-feather="search" className="feather-search" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="search-path d-flex">
                                    <Link className={`btn btn-filter ${isFilterVisible ? "setclose" : ""}`} id="filter_search">
                                        <Filter
                                            className="filter-icon"
                                            onClick={toggleFilterVisibility}
                                        />
                                        <span onClick={toggleFilterVisibility}>
                                            <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
                                        </span>
                                    </Link>
                                </div>
                            </div>
                            {/* /Filter */}
                            <div
                                className={`card${isFilterVisible ? " visible" : ""}`}
                                id="filter_inputs"
                                style={{ display: isFilterVisible ? "block" : "none" }}
                            >
                                <div className="card-body pb-0">
                                    <div className="row">
                                        <div className="col-lg-2 col-sm-6 col-12">
                                            <label className='form-label'>Status</label>
                                            <div className="input-blocks">
                                                <Select 
                                                    options={statusFilter} 
                                                    styles={customStyles}
                                                    className="select" 
                                                    placeholder="Choose status" 
                                                    onChange={handleStatsuChange}
                                                />
                                            </div>
                                        </div>
                                       
                                        <div className="col-lg-3 col-sm-6 col-12">
                                            <label className='form-label'>Date</label>
                                            <div className="input-blocks">
                                                <i data-feather="calendar" className="info-img" />
                                                <div className="input-groupicon">
                                                    <input
                                                        className="form-control"
                                                        value={selectedDate}
                                                        onChange={handleDateChange}
                                                        type="date"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                                            <div className="input-blocks">
                                                <Link className="btn btn-filters ms-auto" onClick={handleSearchClick}>
                                                    {" "}
                                                    <i data-feather="search" className="feather-search" />{" "}
                                                    Search{" "}
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Filter */}
                             <div className="table-responsive">
                                {loading ? (
                                    <SpinLoader/>
                                    // <div className="loader m-auto"></div>
                                ) : (
                                    <Table columns={columns} dataSource={filteredData} />
                                )}
                            </div>
                        </div>
                    </div>
                    {/* /product list */}
                </div>
            </div>
            <AddPurchaseRequest/>
            <ViewApprovedIndents />
            <ViewConsolidatedIndents />
            <ViewPurchaseRequest tranViewObj={viewTranData}/>
            <EditPurchaseRequest tranObj={editTranData}/>
            <SubmittedToPO PRObj={submittedToPO}/>
        </div>
    )
}

export default PurchaseRequests
